import {useLinkTo} from '@react-navigation/native';
import React, {useEffect, useRef, useState} from 'react';
import {Dimensions, StyleSheet, View, Image, Animated, FlatList, Text} from 'react-native';
import {Badge, Card, Col, Container, Row, ListGroup} from 'react-bootstrap';
import HomeHeader from '../components/HomeHeader';
import Loading from '../components/Loading';
import {GetNetworkProvider} from '../network/NetworkProvider';
import { getLcoContactDetails, getBouquesForAccount, getLastTransaction } from '../network/Network';
import { storeCartItems } from '../database/DataBase';
import Calendar from 'react-calendar';
import { TouchableOpacity } from 'react-native-gesture-handler';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

export default function NewHomeScreen(props) {

  const context = GetNetworkProvider();
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [operator, setOperator] = useState({});
  const [activePacks, setActivePacks] = useState([]);
  const [value, onChange] = useState(new Date());
  const [lastTransaction, setLastTransaction] = useState(null);
  const [basePackExpiryDate, setBasePackExpiryDate] = useState(new Date());

  const linkTo = useLinkTo();

  const Id = context.profileInfo
    ? context.profileInfo.data
      ? context.profileInfo.data.profile.customer_id
        ? context.profileInfo.data.profile.customer_id
        : 'Loading...'
      : 'Loading...'
    : 'Loading...';

  useEffect(() => {
    getBouquesForAccount()
      .then((json) => {
        if (json.success === true && json.status === 200) {
          const active = [];
          json.data.forEach(element => {
            if(element.bouque_type != 0){
              if(new Date().getTime() > new Date(element.activation_date).getTime()){
                active.push(element);
              }
            }
          });
          setActivePacks(active);
        }
        getLcoContactDetails()
          .then((json) => {
            setOperator(json.data);
            setIsLoading(false);
          });
      })
      .catch((e) => {
        console.log(e);
        getLcoContactDetails()
          .then((json) => {
            setOperator(json.data);
            setIsLoading(false);
          });
      });

      getLastTransaction()
        .then((json) => {
          console.log(json);
          setLastTransaction(json.data[0]);
        });
  }, [context]);

  useEffect(() => {
    storeCartItems('');
    getBouquesForAccount()
      .then((json) => {
        if (json.success === true && json.status === 200) {
          const active = [];
          const basePacks = [];
          json.data.forEach(element => {
            if(element.bouque_type != 0){
              if(new Date().getTime() > new Date(element.activation_date).getTime()){
                active.push(element);
              }
            }
            if(element.bouque_type == 1){
              basePacks.push(element);
            }
          });
          setActivePacks(active);
          if(basePacks.length > 1){
            setBasePackExpiryDate(new Date(basePacks[basePacks.length - 1].deactivation_date));
          } else{
            setBasePackExpiryDate(new Date(basePacks[0].deactivation_date));
          }
        }
        getLcoContactDetails()
          .then((json) => {
            setOperator(json.data);
            setIsLoading(false);
          });
      })
      .catch((e) => {
        console.log(e);
        getLcoContactDetails()
          .then((json) => {
            setOperator(json.data);
            setIsLoading(false);
          });
      });

    getLastTransaction()
      .then((json) => {
        setLastTransaction(json.data[0]);
      });
  }, []);

  const onPlusIconPress = () => {
    linkTo('/customers/select_packs');
  };

  const onBouquePress = () => {
    linkTo('/customers/bouques');
  };

  const onTransactionPress = () => {
    linkTo('/customers/transactions');
  };

  const onContactPress = () => {
    linkTo('/customers/contact');
  };
  
  const getBouqueNameFromType = (type) => {
    switch (type) {
      case 0:
        return 'NCF';
      case 1:
        return 'BASE';
      case 2:
        return 'ADDON';
      case 3:
        return 'ALACARTE';
      default:
        return;
    }
  };
  
  const getBadgeVariantFromType = (type) => {
    switch (type) {
      case 0:
        return 'warning';
      case 1:
        return 'danger';
      case 2:
        return 'primary';
      case 3:
        return 'success';
      default:
        return;
    }
  };

  const formatDate = (str) => {
    let d = new Date(str);
    return d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear();
  }

  const keyExtractor = (item, index) => index.toString();

  const renderItem = ({item, index}) => {
    return (
      <Card text="white" style={{ backgroundColor: 'black', width: '18rem' }}>
        <Card.Body>
          <Text style={styles.cardTitleStyle}>{item.name}</Text>
          <View style={styles.priceViewStyle}>
            <Text style={styles.priceTextStyle}>Rs. {parseFloat(item.mrp).toFixed(2)}/-</Text>
            <Badge
              style={{alignSelf: 'center'}}
              variant={getBadgeVariantFromType(item.bouque_type)}>
              {getBouqueNameFromType(item.bouque_type)}
            </Badge>
          </View>
          <View style={styles.priceViewStyle}>
            <View>
              <Text style={styles.textStyle}>Expiry Date</Text>
              <Text style={styles.textHeaderStyle}>
                {formatDate(item.deactivation_date)}
              </Text>
            </View>
            <View>
              <Text style={styles.textStyle}>Days Left</Text>
              <Text style={styles.textHeaderStyle}>
                {item.left}
              </Text>
            </View>
          </View>
        </Card.Body>
      </Card>
    );
  }

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation}/>
      {isLoading ? (
        <View style={styles.indicatorViewStyle}>
          <Loading />
        </View>
      ) : (
        <Container>
          <Row style={{ marginTop: 32, marginBottom: 32 }}>
            <Col md={12} sm={12} xs={12}>
              <Text style={{ color: 'gold', fontSize: 24, fontWeight: 'bold' }}>
                Welcome, {' '}
                {context.profileInfo
                  ? context.profileInfo.data
                    ? context.profileInfo.data.profile
                      ? context.profileInfo.data.profile.name
                        ? context.profileInfo.data.profile.name
                        : ''
                      : ''
                    : ''
                  : ''
                }
              </Text>
            </Col>
          </Row>
          <Row>
            <Col md={4} sm={6} xs={12} style={{ marginBottom: 16 }}>
              <Card text={'white'} style={{ backgroundColor: 'black' }}>
                <Card.Body>
                  <View style={{ flexDirection: 'row' }}>
                    <Image source={process.env.PUBLIC_URL + '/assets/user.png'} style={{height: 48, width: 48}}/>
                    <View style={{ marginHorizontal: 16 }}>
                      <Text style={{ color: 'white', marginBottom: 4, fontSize: 14, fontWeight: '500' }}>Subscriber Id</Text>
                      <Text style={{ color: 'white', fontWeight: '700', fontSize: 18 }}>{Id}{' '}</Text>
                    </View>
                  </View>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={6} xs={12} style={{ marginBottom: 16 }}>
              <Card text={'white'} style={{ backgroundColor: 'black' }}>
                <Card.Body>
                  <View style={{ flexDirection: 'row' }}>
                    <Image source={process.env.PUBLIC_URL + '/assets/calendar.png'} style={{height: 48, width: 48}}/>
                    <View style={{ marginHorizontal: 16 }}>
                      <Text style={{ color: 'white', marginBottom: 4, fontSize: 14, fontWeight: '500' }}>Last recharged on</Text>
                      <Text style={{ color: 'white', fontWeight: '700', fontSize: 18 }}>{lastTransaction != null ? formatDate(lastTransaction?.created_at) : ''}</Text>
                    </View>
                  </View>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={6} xs={12} style={{ marginBottom: 16 }}>
              <Card text={'white'} style={{ backgroundColor: 'black' }}>
                <Card.Body>
                  <View style={{ flexDirection: 'row' }}>
                    <Image source={process.env.PUBLIC_URL + '/assets/rupee1.png'} style={{height: 48, width: 48}}/>
                    <View style={{ marginHorizontal: 16 }}>
                      <Text style={{ color: 'white', marginBottom: 4, fontSize: 14, fontWeight: '500' }}>Last recharge amount</Text>
                      <Text style={{ color: 'white', fontWeight: '700', fontSize: 18 }}>Rs. {lastTransaction?.total_amount}</Text>
                    </View>
                  </View>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={4} sm={12} xs={12} style={{ marginBottom: 16 }}>
              <Row>
                <Col md={6} xs={6}>
                  <Card style={{ backgroundColor: '#000000' }}>
                    <Card.Body>
                      <Card.Title style={{ color: 'white', fontWeight: 'bold', fontSize: 18 }}>Next Recharge On (Base Pack)</Card.Title>
                      <View style={{ flexDirection: 'column', elevation: 8, borderRadius: 8, backgroundColor: 'white' }}>
                        <Text style={styles.textMonth}>{monthNames[basePackExpiryDate.getMonth()]}</Text>  
                        <Text style={styles.textDate}>{basePackExpiryDate.getDate()}</Text>  
                      </View>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} xs={6}>
                  <TouchableOpacity style={{ height: '100%' }}>
                    <Card text={'white'} style={{ backgroundColor: 'black', height: '100%'}}>
                      <Card.Img
                        variant="top"
                        src={process.env.PUBLIC_URL + '/assets/rupee2.png'}
                        style={{ height: 48, width: 48, alignSelf: 'center', marginTop: 52 }}/>
                      <Card.Body style={{ textAlign: 'center' }}>
                        <Card.Title style={{ fontWeight: 'bold' }}>
                          Recharge <br/> Now
                        </Card.Title>
                      </Card.Body>
                    </Card>  
                  </TouchableOpacity>
                </Col>
              </Row>
            </Col>
            <Col md={8} sm={12} xs={12} style={{ marginBottom: 16 }}>
              <View style={{ height: '100%'  }}>
                <Card text={'white'} style={{ backgroundColor: 'black'}}>
                  <Card.Body>
                    <Card.Title style={{  fontWeight: 'bold' }}>LCO Details (For Complaints)</Card.Title>
                    <Row>
                      <Col md={6} xs={12} style={{ marginBottom: 16 }}>
                        <View style={{ borderBottomWidth: 1, borderBottomColor: 'white', marginHorizontal: 8}}>
                          <Text style={styles.textStyleBold}>Name:&nbsp;</Text> 
                          <Text style={{ color: 'white', fontSize: 16, textAlignVertical: 'bottom', alignSelf: 'baseline' }}>{operator.name}</Text> 
                        </View>  
                      </Col>
                      <Col md={6} xs={12} style={{ marginBottom: 16 }}>
                        <View style={{ borderBottomWidth: 1, borderBottomColor: 'white', marginHorizontal: 8}}>
                          <Text style={styles.textStyleBold}>Phone:&nbsp;</Text> 
                          <Text style={{ color: 'white', fontSize: 16 }}>{operator.mobile_no}</Text> 
                        </View>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12} style={{ marginBottom: 16 }}>
                        <View style={{ borderBottomWidth: 1, borderBottomColor: 'white', marginHorizontal: 8}}>
                          <Text style={styles.textStyleBold}>Email:&nbsp;</Text> 
                          <Text style={{ color: 'white', fontSize: 16 }}>{operator.email}</Text> 
                        </View>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </View>
            </Col>
          </Row>
          <Row>
            <Col md={3} sm={6} xs={6} style={{ marginBottom: 16 }}>
              <TouchableOpacity onPress={onPlusIconPress}>
                <Card text={'white'} style={{ backgroundColor: 'black' }}>
                  <Card.Img
                    variant="top" 
                    src={process.env.PUBLIC_URL + '/assets/plus.png'}
                    style={{ height: 48, width: 48, alignSelf: 'center', marginTop: 16 }}/>
                  <Card.Body style={{ textAlign: 'center' }}>
                    <Card.Title style={{ fontWeight: 'bold' }}>
                      Add New <br/> Packs
                    </Card.Title>
                  </Card.Body>
                </Card>
              </TouchableOpacity>
            </Col>
            <Col md={3} sm={6} xs={6} style={{ marginBottom: 16 }}>
              <TouchableOpacity onPress={onBouquePress}>
                <Card text={'white'} style={{ backgroundColor: 'black' }}>
                  <Card.Img 
                    variant="top" 
                    src={process.env.PUBLIC_URL + '/assets/cells.png'}
                    style={{ height: 48, width: 48, alignSelf: 'center', marginTop: 16 }}/>
                  <Card.Body style={{ textAlign: 'center' }}>
                    <Card.Title style={{ fontWeight: 'bold' }}>
                      Manage\Renew <br/> Packs
                    </Card.Title>
                  </Card.Body>
                </Card>
              </TouchableOpacity>
            </Col>
            <Col md={3} sm={6} xs={6} style={{ marginBottom: 16 }}>
              <TouchableOpacity onPress={onTransactionPress}>
                <Card text={'white'} style={{ backgroundColor: 'black' }}>
                  <Card.Img 
                    variant="top" 
                    src={process.env.PUBLIC_URL + '/assets/transaction.png'} 
                    style={{ height: 48, width: 48, alignSelf: 'center', marginTop: 16 }}/>
                  <Card.Body style={{ textAlign: 'center' }}>
                    <Card.Title style={{ fontWeight: 'bold' }}>
                      Transactions &amp; <br/> Receipts
                    </Card.Title>
                  </Card.Body>
                </Card>
              </TouchableOpacity>
            </Col>
            <Col md={3} sm={6} xs={6} style={{ marginBottom: 16 }}>
              <TouchableOpacity onPress={onContactPress}>
                <Card text={'white'} style={{ backgroundColor: 'black' }}>
                  <Card.Img 
                    variant="top" 
                    src={process.env.PUBLIC_URL + '/assets/contact.png'}
                    style={{ height: 48, width: 48, alignSelf: 'center', marginTop: 16 }}/>
                  <Card.Body style={{ textAlign: 'center' }}>
                    <Card.Title style={{ fontWeight: 'bold' }}>
                      Contact Your <br/> Cable Operator
                    </Card.Title>
                  </Card.Body>
                </Card>
              </TouchableOpacity>
            </Col>
          </Row>
          <Row style={{ marginBottom: 32 }}>
            <Col md={12} sm={12} xs={12}>
              {
                activePacks.length > 0 && (
                  <Text style={{ color: 'gold', fontSize: 24, fontWeight: 'bold' }}>Active Packs</Text>
                )
              }
              <FlatList
                horizontal
                style={{ marginTop: 16 }}
                data={activePacks}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                showsHorizontalScrollIndicator={false}
                ItemSeparatorComponent={() => {
                  return (
                      <View
                        style={{
                          height: "100%",
                          width: 20,
                          backgroundColor: "#00000000",
                        }}
                      />
                  );
              }}
              />    
            </Col>
          </Row>
        </Container>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT
  },
  indicatorViewStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  mainViewStyle: {
    alignItems: 'center',
    backgroundColor: '#1a191f',
  },
  textStyleBold: { 
    color: 'white', 
    fontSize: 18, 
    fontWeight: '500' 
  },
  rowStyle: {
    flexDirection: 'row'
  },
  cardContainerStyle: {
    marginHorizontal: 8,
    width: 300,
    elevation: 8,
    borderWidth: 0,
    borderRadius: 8,
    backgroundColor: 'black',
  },
  cardTitleStyle: {
    color: 'white',
    fontSize: 15,
    textTransform: 'uppercase',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
    justifyContent: 'center'
  },
  priceViewStyle: {
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  priceTextStyle: {
    fontSize: 18,
    color: 'silver',
    fontWeight: 'bold',
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  textStyle: {
    fontSize: 12,
    color: 'grey',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  textHeaderStyle: {
    fontSize: 15,
    color: 'orange',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  textMonth: {
    fontSize: 20,
    color: 'white',
    fontWeight: 600,
    backgroundColor: 'red',
    padding: 8,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    alignSelf: 'center',
    width: '100%'
  },
  textDate: { 
    fontSize: 36, 
    color: 'black', 
    alignSelf:'center', 
    paddingVertical: 8,
    fontWeight: 'bold',
    borderBottomLeftRadius: 8, 
    borderBottomRightRadius: 8 
  }
});
